import axios from "@/http/axios"
import { getCurrentTenant } from '@/utils'

export default {
  async fetch(
    token,
    tenantIds= [],
    search = '',
    page = 1,
    limit = 4,
  ) {
    try {
      axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/reasons';
      return await axios.get('', {
        params: {
          search: search,
          tenant_ids: tenantIds,
          pagination_page: page,
          pagination_limit: limit
        },
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
    } catch (e) {
      console.error(e);
      return [];
    }
  }
}